import { makeEmptyCaption } from '@pm2/content-engine';
import { defaultPm2PrintChunkClassName } from '@provider/print';
import { AudioPlayer } from './organism.audio-component/molecule.player/_player.js';
import { Scrambled } from './organism.video-component/atom.scrambled.js';
import { jsx } from 'react/jsx-runtime';

const printAudioComponentPaper = () => {
  return [{
    containerClassName: defaultPm2PrintChunkClassName,
    content: /*#__PURE__*/jsx(AudioPlayer, {
      src: "",
      caption: makeEmptyCaption(),
      isScrambled: true
    })
  }];
};
const print23VideoComponentPaper = () => {
  return [{
    containerClassName: defaultPm2PrintChunkClassName,
    content: /*#__PURE__*/jsx(Scrambled, {})
  }];
};
const mediaComponentPaperPrinters = {
  "audio-component": printAudioComponentPaper,
  "23-video-component": print23VideoComponentPaper
};

export { mediaComponentPaperPrinters };
//# sourceMappingURL=printer.to-paper.js.map
